import React, { useContext } from 'react';

// import { EditorView } from "@atlaskit/editor-prosemirror/dist/types/view";
import type { ProviderFactory } from '@atlaskit/editor-common/provider-factory';
import type { UiComponentFactoryParams } from '@atlaskit/editor-common/src/types';
import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import type {
	AIProactivePluginConfig,
	AIProactivePluginInjectionAPI,
} from '../../aiProactivePluginType';

export interface ContentComponentProps {
	api: AIProactivePluginInjectionAPI;
	appearance: UiComponentFactoryParams['appearance'];
	config: AIProactivePluginConfig;
	editorView: EditorView;
	providerFactory: ProviderFactory;
	wrapperElement: UiComponentFactoryParams['wrapperElement'];
}

const ContentComponentContext = React.createContext<ContentComponentProps | undefined>(undefined);

export const ContentComponentContextProvider = ContentComponentContext.Provider;

/**
 * @example
 * ```tsx
 * const {editorView, api} = useContentComponentContext();
 * ```
 */
export const useContentComponentContext = (): ContentComponentProps => {
	const context = useContext(ContentComponentContext);
	if (!context) {
		throw new Error(
			'No Editor view or API available in the context, make sure to have container wrapped with ContentComponentContextProvider',
		);
	}
	return context;
};
